import { Team, TeamMember, TodoTasksBoard } from '@demind-inc/core';
import { useQuery } from '@tanstack/react-query';

import { teamApi } from '../api';

interface UseTeamParams {
  userId: string;
  teamId?: string;
}

export interface TeamDetailResult {
  team: Team;
  membership: TeamMember;
  members: TeamMember[];
  boards: TodoTasksBoard[];
}

export const TEAM_DETAIL_QUERY_KEY = ['lifestack.team.detail'];

export const useTeam = ({ userId, teamId }: UseTeamParams) => {
  const teamQuery = useQuery({
    queryKey: ['lifestack.team.detail', { userId, teamId }],
    queryFn: () => {
      return teamApi.getTeam(teamId!).then(({ data }) => {
        return {
          team: data.team as Team,
          membership: data.membership as TeamMember,
          members: (data.members ?? []) as TeamMember[],
          boards: (data.boards ?? []) as TodoTasksBoard[],
        };
      });
    },
    refetchOnWindowFocus: false,
    enabled: !!userId && !!teamId,
    staleTime: 5000,
  });

  return {
    team: teamQuery.data?.team ?? null,
    membership: teamQuery.data?.membership ?? null,
    members: teamQuery.data?.members ?? [],
    boards: teamQuery.data?.boards ?? [],
    ...teamQuery,
  };
};
